import { Currency } from '@aslanpay/portal-common-lib';

/**
 * Get the currency symbol for a given currency code
 * TODO move to common lib
 */
// eslint-disable-next-line import/prefer-default-export
export const getCurrencySymbolForCode = (currencyCode: Currency): string => {
  const amount = 0;
  const options: Intl.NumberFormatOptions = { style: 'currency', currency: currencyCode };

  // Hack to use the locale that matches the currency to get the cleanest symbol
  // otherwise some symbols come with extra characters (e.g. USD $ comes as US$)
  let locale = 'en-US';
  if (currencyCode === 'GBP') {
    locale = 'en-GB';
  } else if (currencyCode === 'EUR') {
    locale = 'en-IE';
  }

  const numberFormat = new Intl.NumberFormat(locale, options);

  const parts = numberFormat.formatToParts(amount);
  return parts.find((p) => p.type === 'currency')?.value ?? currencyCode;
};
